module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-select-account"
  }, _vm._l((_vm.accounts), function(account) {
    return _c('a', {
      staticClass: "w-select-account__row",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSelectAccount(account)
        }
      }
    }, [_c('span', {
      staticClass: "w-select-account__image",
      style: ({
        backgroundImage: _vm.getBackgroundImage(account)
      })
    }), _c('span', {
      staticClass: "w-select-account__row-content"
    }, [_c('strong', {
      staticClass: "w-select-account__name"
    }, [_vm._v(_vm._s(account.installation.name))]), _c('span', {
      staticClass: "w-select-account__owner"
    }, [_vm._v(_vm._s(account.user.firstName + ' ' + account.user.lastName))]), _c('span', {
      staticClass: "w-select-account__url"
    }, [_vm._v(_vm._s(account.installation.url))])]), (account.installation.region === 'EU') ? _c('span', {
      staticClass: "w-select-account__eu-flag"
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/images/eu-flatflag-mini.svg"),
        "alt": "EU"
      }
    })]) : _vm._e(), (account.installation.region === 'AU') ? _c('span', {
      staticClass: "w-select-account__au-flag"
    }, [_vm._v("AU")]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37372ab8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/AccountList/AccountList.vue
// module id = 594
// module chunks = 1